import React from 'react';
import { Spring } from 'react-spring';

import Blog from './Blog';

import Clubhouse from './images/clubhouse.png';
import User from './images/user.png';
import Headspace from './images/headspace.png';

/* eslint-disable camelcase */
import styles from './style.css';

const blogs = [
  {
    image: Clubhouse,
    name:
      'How Clubhouse Became The Hottest Social Media App with Exclusive User Experiences',
    description:
      'Learn how Clubhouse combined hype and exclusivity with a great UX to generate demand, and why their atypical app launch strategy could hurt them in the long run.',
    link: 'https://wearewip.com/blog/clubhouse-became-the-hottest',
    delay: 580
  },
  {
    image: User,
    name:
      'How to Build a User Acquisition Strategy: 5 Approaches and Tactics for 2021',
    description:
      'This guide teaches you exactly how to deploy a user acquisition strategy to get more users downloading and using your mobile app in 2021.',
    link: 'https://wearewip.com/blog/user-acquisition',
    delay: 760
  },
  {
    image: Headspace,
    name:
      'How Headspace Became a $320 Million Brand with Great App & UI Design',
    description:
      'Hoping to build the next million-dollar app brand? Discover here how the founders and developers behind Headspace, a meditation guide, achieved just that.',
    link: 'https://wearewip.com/blog/how-headspace-became',
    delay: 660
  }
];

/* eslint-enable camelcase */

const Blogs = () => (
  <div className={styles.blogs}>
    {blogs.map(({ delay, ...blog }) => (
      <Spring
        key={blog.name}
        delay={delay}
        native
        from={{ transform: 'translate3d(0, 100vh, 0)' }}
        to={{ transform: 'translate3d(0, 0vh, 0)' }}
      >
        {computedStyle => <Blog {...blog} style={computedStyle} />}
      </Spring>
    ))}
    <a className={styles.allblogs} href="https://wearewip.com/blog">
      Check all our posts
    </a>
  </div>
);

export default Blogs;
